import AutoComplete from './helpers/autocomplete';
import { analyticsInit } from './helpers/analyticsInit.js';

const configs = [
  {
    selector: '[id$=customer-address]',
    resultType: ['address'],
    formMappings: {
      street_number: 'customerAddress',
      subpremise: 'customerAddress2',
      route: 'customerAddress',
      locality: 'customerCity',
      administrative_area_level_1: 'customerState',
      postal_code: 'customerPostalCode'
    }
  },
  {
    selector: '[id$=church-address]',
    resultType: ['church', 'place_of_worship'],
    formMappings: {
      street_number: 'organizationAddress',
      route: 'organizationAddress',
      locality: 'organizationCity',
      administrative_area_level_1: 'organizationState',
      postal_code: 'organizationPostalCode',
      phone: 'organizationPhone',
      name: 'organizationName'
    }
  }
];

const initLeadForm = () => {
  configs.forEach(({ selector, resultType, formMappings }) => {
    const elem = document.querySelector(selector);
    if (elem) {
      AutoComplete({
        elem,
        resultType,
        formMappings
      });
    }
  });
};

analyticsInit();
initLeadForm();
